/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

var props = {
  backgroundColor: {
    type: String,
    default: ""
  },
  customStyle: {
    type: String,
    default: ""
  },
  duration: {
    type: Number,
    default: 300
  },
  preventScrollThrough: {
    type: Boolean,
    default: true
  },
  visible: Boolean,
  zIndex: {
    type: Number,
    default: 1e3
  },
  onClick: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
